<template>
	<div>
		<CustomTable
			:id_table="table_id"
			:ref="table_id"
			:dateFilter="with_period ? period : false"
			:periodToShow="periods"
			@dateRangeSubmit="loadInvoicesSupplier"
			:items="invoices"
			:busy.sync="table_busy"
			primaryKey="suppliersocr_id"
			:hide_if_empty="true"
			:hrefsRoutes="config_table_hrefs"
			:externSlotColumns="extern_slot_columns"
			:groupByCustom="customGroupBy"
			class="mt-2"
		>
			<template v-slot:[`custom-slot-cell(suppliersocr_num)`]="{ data }">
				<router-link :to="{ name: 'invoiceSupplierFicheOverview', params: { invoicesupplier_id: data.suppliersocr_id } }">
					{{ data.suppliersocr_num }}
				</router-link>
				<a href="" class="ml-1" @click.prevent="quickPreview(data.suppliersocr_pdf_url)"><font-awesome-icon :icon="['fas', 'eye']" /></a>
			</template>
			<template v-slot:[`custom-slot-cell(status)`]="{ data }">
				{{ $t('invoice.supplier_status.' + data.status) }}
			</template>
			<template v-slot:[`custom-slot-cell(lifecycle_status)`]="{ data }">
				<span v-if="data.suppliersocr_lifecycle_code">{{ data.suppliersocr_lifecycle_code }} - {{ $t('invoice.supplier_lifecycle_status.' + data.suppliersocr_lifecycle_code) }}</span>
			</template>
			<template v-slot:[`custom-slot-cell(paymentmethod_code)`]="{ data }">
				<span v-if="data.paymentmethod_code">{{ $t('payment.payment_method_labels.' + data.paymentmethod_code.toLowerCase()) }}</span>
			</template>
			<template v-slot:[`custom-slot-cell(bucket)`]="{ data }">
				<span v-if="data.bucket">{{ $t('invoice.supplier_bucket.' + data.bucket) }}</span>
			</template>
			<template v-slot:[`custom-slot-cell(suppliersocr_export_status)`]="{ data }">
				<span :class="'export_status_' + data.suppliersocr_export_status">{{ $t('invoice.supplier_export_status.' + data.suppliersocr_export_status) }}</span>
			</template>
			<template v-slot:custom-slot-cell(horses)="{ data }">
				<span v-for="horse, index in data.horses" :key="index">
					<router-link :to="{ name: 'horseFiche', params: { horse_id: horse.horse_id }}">
						{{ horse.horse_nom }}
					</router-link>
					<span v-if="index != data.horses.length - 1">, </span>
				</span>
			</template>
			<template v-slot:[`custom-slot-cell(suppliersocr_duedate_date)`]="{ data }">
				<span v-for="duedate in data.duedates" :key="duedate.isduedate_id">
					{{ formatDate(duedate.isduedate_date) }}<br>
				</span>
				<span v-if="data.duedates.length == 0">{{ formatDate(data.suppliersocr_duedate_date) }}</span>
			</template>
		</CustomTable>

		<b-modal size="xl" ref="modelPreview" hide-footer @hidden="pdf_url = null">
			<template v-slot:modal-title>{{ $t("action.previsualiser") }}</template>

			<iframe v-if="pdf_url != null" :src="pdf_url" height="1000px" width="100%" style="position:relative"></iframe>
			<img v-else-if="img_url != null" :src="img_url" class="w-100"/>
			<LoadingSpinner v-else />
		</b-modal>

		<SepaTransfer ref="sepa_transfer" @submit="onSepaTransferConfirmed" />
	</div>
</template>


<script type="text/javascript">
	import Invoice from "@/mixins/Invoice.js"
	import Navigation from "@/mixins/Navigation.js"
	import Config from "@/mixins/Config.js"
	import Shutter from "@/mixins/Shutter.js"
	import ShutterInvoice from "@/mixins/shutters-manager/Invoice.js"
	import { EventBus } from "EventBus"

	export default {
		name: 'InvoiceSupplierBucketList',

		mixins: [Invoice, Navigation, Config, Shutter, ShutterInvoice],

		props: {
			// Vue de suivi affichée : inbox, to-process, approved, disputed…
			bucket: { type: String, required: true },
			tiers_id: { type: [String, Number], default: null },
			// Période imposée par l'adresse, au format YYYY-MM-DD. Elle vient d'un lien qui désigne une
			// facture précise, et prégarnit le sélecteur pour que la vue s'ouvre là où elle se trouve.
			start_date: { type: String, default: null },
			end_date: { type: String, default: null }
		},

		data() {
			// Par défaut, le dernier mois : de la date du jour à un mois en arrière.
			const default_start = new Date()
			default_start.setMonth(default_start.getMonth() - 1)

			return {
				invoices: [],
				table_busy: false,
				period: {
					start: this.start_date ? new Date(this.start_date) : default_start,
					end: this.end_date ? new Date(this.end_date) : new Date(),
					persistId: ''
				},
				pdf_url: null,
				img_url: null,
				events_tab: {
					'TableAction::goToEditInvoiceSupplier': this.goToControlInvoiceSupplier,
					'TableAction::goToPrintInvoiceSupplier': this.printInvoiceSupplier,
					'TableAction::goToDeleteInvoiceSupplier': this.goToDeleteInvoiceSupplier,
					'TableAction::goToAddPaymentSupplier': this.setUpPaymentInvoiceSupplier,
					'TableAction::goToAddChargeAccountSupplier': this.goToVentilation,
					'TableAction::goToExportComptableSupplier': this.export_comptable,
					'TableAction::goToAccountedSupplier': this.accounted,
					'TableAction::goToSepaTransferSupplier': this.setUpSepaTransfer,
				},
				extern_slot_columns: ['suppliersocr_num', 'status', 'lifecycle_status', 'suppliersocr_export_status', 'horses', 'suppliersocr_duedate_date', 'bucket', 'paymentmethod_code'],
				config_table_hrefs: {
					'entity.tiers_rs': {
						routeUniqueName: 'entityTableauBord',
						routeName: 'tiersTableauBord',
						params: { tiers_id: 'entity.tiers_id' }
					},
					'tier.tiers_rs': {
						routeUniqueName: 'tiersTableauBord',
						routeName: 'tiersTableauBord',
						params: { tiers_id: 'tier.tiers_id' }
					}
				},
				customGroupBy: {'status': this.getTradStatus, 'paymentmethod_code': this.getTradPaymentMethod}
			}
		},

		computed: {
			/**
			 * Les vues de suivi partagent la configuration de colonnes des factures contrôlées : ce sont
			 * les mêmes données, et une configuration par onglet serait dix fois à maintenir. Les vues
			 * transversales ont en revanche chacune la leur, parce qu'elles seules affichent la vue de
			 * suivi où chaque facture se trouve — sur un onglet, cette colonne ne répéterait que son
			 * propre en-tête — et que chacune porte ses propres actions.
			 */
			table_id() {
				const transverse_tables = {
					'to-allocate': 'invoice_suppliers_ocr_to_allocate',
					'to-export': 'invoice_suppliers_ocr_to_export'
				}

				return transverse_tables[this.bucket] || 'invoice_suppliers_ocr_checked'
			},

			/**
			 * Vues où la période s'impose : celles qui gardent les factures une fois l'affaire close,
			 * et dont le volume ne cesse de croître. Une facture partiellement soldée reste due — elle
			 * doit rester visible quelle que soit son ancienneté. Les vues transversales en relèvent
			 * aussi : rien n'en sort une facture tant qu'elle n'a pas été imputée ou comptabilisée, et
			 * un exercice ne se rattrape pas en regardant tout l'historique — c'est d'ailleurs par
			 * période que l'on transmet les écritures au cabinet.
			 */
			with_period() {
				return ['paid', 'rejected', 'to-allocate', 'to-export'].includes(this.bucket)
			},

			/**
			 * Clé sous laquelle le sélecteur mémorise la période. La vue d'un fournisseur a la sienne :
			 * partagée avec la vue de toutes les factures, elle y imposerait sa période de cinq ans, et
			 * reprendrait en retour celle de l'exercice en cours.
			 */
			persist_id() {
				return (this.tiers_id ? 'InvoiceSupplierTiers' : 'InvoiceSupplier') + this.bucket
			},

			periods() {
				if(this.bucket == 'paid') {
					return ['personalise', 'mois', 'mois_dernier', 'annee_en_cours', 'annee_derniere']
				}
				return ['personalise', 'mois_dernier', 'annee_en_cours', 'annee_derniere']
			}
		},

		watch: {
			// Le composant sert toutes les vues : changer d'onglet ne le détruit pas, il recharge.
			bucket() {
				this.restorePeriod()
				this.loadInvoicesSupplier()
			}
		},

		// Avant la création du sélecteur, qui lance la première recherche avec les dates qu'on lui passe.
		created() {
			this.restorePeriod()
		},

		methods: {
			/**
			 * Reprend la dernière période recherchée sur la vue, sauf si l'adresse en impose une : elle
			 * vise une facture précise.
			 */
			restorePeriod() {
				this.period.persistId = this.persist_id
				if(!this.with_period || (this.start_date && this.end_date)) {
					return
				}

				const start = this.getConfig('startDate' + this.persist_id)
				const end = this.getConfig('endDate' + this.persist_id)
				if(start && end) {
					this.period.start = new Date(start)
					this.period.end = new Date(end)
				}
			},

			/**
			 * Mémorise la période recherchée. Celle imposée par l'adresse ne l'est pas tant qu'on ne l'a
			 * pas changée : suivre un lien vers une ancienne facture ne doit pas déplacer la période de la vue.
			 */
			savePeriod() {
				const start = this.period.start.toDateInputValue()
				const end = this.period.end.toDateInputValue()
				if(start == this.start_date && end == this.end_date) {
					return
				}

				this.setConfig('startDate' + this.persist_id, this.period.start)
				this.setConfig('endDate' + this.persist_id, this.period.end)
			},

			async loadInvoicesSupplier() {
				if(this.$refs[this.table_id]) {
					this.$refs[this.table_id].unselectAll()
				}

				// Le filtre de comptabilité est tenu par l'en-tête de la page, pour tous les onglets.
				let entity_ids = this.getConfig('invoice_suppliers_entities') || []
				// dans la fiche tiers je ne filtre par sur les entités donc je passe le tableau à vide
				if(this.tiers_id) {
					entity_ids = []
				}

				this.table_busy = true

				// La période porte sur la date d'émission de la facture, celle du document — la même
				// que sur les autres écrans comptables.
				const period = this.with_period && this.period.start && this.period.end
					? { start: this.period.start.toDateInputValue(), end: this.period.end.toDateInputValue() }
					: null

				if(period) {
					this.savePeriod()
				}

				this.invoices = await this.getInvoiceSupplierBucket(this.bucket, entity_ids, this.tiers_id, period)
				this.table_busy = false
			},

			/**
			 * Reprendre une facture, c'est l'ouvrir sur son onglet Contrôle plutôt que sur le seul
			 * formulaire : la fiche montre le document en regard des montants que l'on corrige, et donne
			 * accès à la ventilation, au cycle de vie et aux règlements. Elle recharge par ailleurs la
			 * facture complète, là où la liste n'en porte que les colonnes affichées.
			 */
			goToControlInvoiceSupplier(invoice) {
				this.$router.push({ name: 'invoiceSupplierFicheControl', params: { invoicesupplier_id: invoice.suppliersocr_id } })
			},

			async goToDeleteInvoiceSupplier(invoicesupplier_ids) {
				await this.deleteInvoiceSupplier(invoicesupplier_ids)
				EventBus.$emit("TableAction::stopSpin")
				this.successToast('toast.info_save_succes')
				this.loadInvoicesSupplier()
				EventBus.$emit('InvoiceSupplier::CountsChanged')
			},

			// L'export fait passer les factures au statut comptable « Exportée » : la liste le montre.
			async export_comptable(invoicesupplier_ids) {
				await this.loadExportComptableSupplier(invoicesupplier_ids)
				EventBus.$emit('TableAction::stopSpin')
				this.loadInvoicesSupplier()
			},

			async accounted(invoicesupplier_ids) {
				await this.setAccountedInvoiceSupplier(invoicesupplier_ids)
				EventBus.$emit('TableAction::stopSpin')
				this.loadInvoicesSupplier()
			},

			/**
			 * La ventilation se saisit dans la fiche de la facture, où le document reste sous les yeux
			 * et où le contrôle et les règlements sont à un onglet de distance.
			 */
			goToVentilation(invoice) {
				this.$router.push({ name: 'invoiceSupplierFicheVentilation', params: { invoicesupplier_id: invoice.suppliersocr_id } })
			},

			setUpSepaTransfer(invoicesupplier_ids) {
				this.$refs.sepa_transfer.open(invoicesupplier_ids)
			},

			// Les factures virées sont soldées : elles quittent la vue courante pour rejoindre les payées.
			onSepaTransferConfirmed() {
				this.loadInvoicesSupplier()
				EventBus.$emit('InvoiceSupplier::CountsChanged')
			},

			/**
			 * Le regroupement par statut affiche la valeur brute de la colonne : sans cela, l'en-tête
			 * du groupe dirait « partially_paid ».
			 */
			getTradStatus(status) {
				const all_status = ['partially_paid', 'paid', 'to_pay']
				return all_status.includes(status) ? this.getTrad('invoice.supplier_status.' + status) : status
			},

			async quickPreview(pdf_url) {
				this.$refs.modelPreview.show()
				this.pdf_url = null
				this.img_url = null

				if(pdf_url.includes('.pdf')) {
					this.pdf_url = pdf_url
				}
				else {
					this.img_url = pdf_url
				}
			}
		},

		mounted() {
			this.loadInvoicesSupplier()

			// Le filtre de l'en-tête vaut pour tous les onglets : la liste se recharge quand il change.
			EventBus.$on('InvoiceSupplier::EntitiesChanged', this.loadInvoicesSupplier)
			EventBus.$on('InvoiceSupplier::Refresh', this.loadInvoicesSupplier)
		},

		beforeDestroy() {
			EventBus.$off('InvoiceSupplier::EntitiesChanged', this.loadInvoicesSupplier)
			EventBus.$off('InvoiceSupplier::Refresh', this.loadInvoicesSupplier)
		},

		components: {
			CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
			SepaTransfer: () => import('@/components/InvoiceSupplier/SepaTransfer')
		}

	}
</script>
